import React, { ReactNode } from 'react';

import styles from './EmptyState.module.scss';
import { images } from './images';

type props = {
  type: // | 'Done'
  // | 'EmptyInbox'
  'Error';
  // | 'NoConnection'
  // | 'NoCreditCard'
  // | 'NoDocuments'
  // | 'NoGPS'
  // | 'NoImages'
  // | 'NoItemsCart'
  // | 'NoMessages'
  // | 'NoSearchResult'
  // | 'NoTasks';
  title?: string | ReactNode;
  description?: string | ReactNode;
  className?: string;
};

function EmptyState({ type = 'Error', title, description, className }: props) {
  const data = {
    // Done: {
    //   title: 'Done!',
    //   description: 'Task is completed successfully',
    // },
    // EmptyInbox: {
    //   title: 'You inbox is empty',
    //   description: 'All incoming requests will be listed in this folder',
    // },
    Error: {
      title: 'Oops!',
      description: 'Something went wrong, please try again',
      image: images.Error,
    },
    // NoConnection: {
    //   title: 'No internet connection',
    //   description: 'Please check your internet connection',
    // },
    // NoCreditCard: {
    //   title: 'No credit cards',
    //   description: 'Please add some credit cart to your account',
    // },
    // NoDocuments: {
    //   title: 'No documents',
    //   description: 'Start creating your documents',
    // },
    // NoGPS: {
    //   title: 'No GPS connection',
    //   description: 'Please check for location permission',
    // },
    // NoImages: {
    //   title: 'No images',
    //   description: 'Start uploading images',
    // },
    // NoItemsCart: {
    //   title: 'Your bag is empty',
    //   description: "Check out what's trending",
    // },
    // NoMessages: {
    //   title: 'No messages',
    //   description: 'You have no active chats',
    // },
    // NoSearchResult: {
    //   title: 'No results found',
    //   description: 'Try adjusting your search to find what you are looking for',
    // },
    // NoTasks: {
    //   title: "You're all caught up!",
    //   description: 'Check back later for new tasks',
    // },
    // Spinner: {
    //   title: 'Processing',
    //   description: 'Hang on while we are working',
    // },
  };

  return (
    <div className={[styles.main, className].join(' ')}>
      <div
        className={styles.image}
        style={{
          backgroundImage: `url('${data[type].image}')`,
        }}
      />
      <span className={styles.title}>{title || data[type].title}</span>
      <span className={styles.description}>
        {description || data[type].description}
      </span>
    </div>
  );
}

export default EmptyState;
